import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { OrderRequestListingContext } from "../../context/OrderRequestListingContext";
import { mapToSendOrderRequestItem } from "../SendOrderRequestSummaryList";
import { SendMultipleOrderRequestsToOnPremDialog } from "./SendMultipleOrderRequestsToOnPremDialog";

export const SendMultipleOrderRequestsToOnPremButton: React.VFC = () => {
    const { selectedItems } = useContext(OrderRequestListingContext);

    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <CommandBarButton
                text="On-Prem Processing"
                icon="Send"
                disabled={!selectedItems.length}
                onClick={onOpen}
                testId="bulk-on-prem-processing-button"
            />
            {isOpen && (
                <SendMultipleOrderRequestsToOnPremDialog
                    key={String(isOpen)}
                    selectedItems={selectedItems.map((item) => mapToSendOrderRequestItem(item))}
                    onClose={onClose}
                />
            )}
        </AuthorizationWrapper>
    );
};
